<template>
  <div>
    <!-- 培训方案 -->
    <div v-show="type == 1">
      <EditTrainProgram
        ref="editTrainProgram"
        :programId="programId"
        :readonly="readonly"
        @changeType="changeType"
        :classes="classesData"
        :topics="topicsData"
        @del="delClass"
        @delTopic="delTopic"
        @confirmTopics="confirmTopicsCheck"
        @resetTopics="resetTopics"
        @addorupdateProgram="addorupdateProgram"
        @cancel="cancel"
        :confirmLoading="confirmLoading"
        @showTopic="showTopic"
      ></EditTrainProgram>
    </div>
    <!-- 选择课程 -->
    <div v-if="type == 2">
      <EditClass
        @changeType="changeType"
        :selectClasses="classesData"
        @confirm="confirmClass"
      ></EditClass>
    </div>
    <!-- 选择题目 -->
    <div v-if="type == 3">
      <EditTopic
        @changeType="changeType"
        :selectTopics="topicsData"
        @confirm="confirmTopics"
        @showTopic="showTopic"
      ></EditTopic>
    </div>
    <ShowTopic ref="showTopic"></ShowTopic>
  </div>
</template>

<script>
import EditTrainProgram from "./components/editTrainProgram"; //新增编辑培训方案
import EditClass from "./components/editClass"; //选择和管理课程
import EditTopic from "./components/editTopic"; //选择和管理课程
import ShowTopic from './components/showTopic'
import {
  addTrainProgram,
  updateTrainProgram,
  trainProgramInfo,
} from "@/request/classes";
export default {
  components: { EditTrainProgram, EditClass, EditTopic, ShowTopic },
  data() {
    return {
      type: 1, //1培训方案2选择课程3选择题目
      programId: "", //培训方案id
      readonly: false, //是否仅查看
      classesData: [],
      topicsData: [],
      confirmLoading: false,
    };
  },
  created() {
    console.log(this.$route.query);
    if (this.$route.query.id) {
      this.programId = this.$route.query.id;
      this.getInfo();
    }
    if (this.$route.query.readonly == 1) {
      this.readonly = true;
    }
  },
  methods: {
    //获取方案详情
    getInfo() {
      trainProgramInfo(this.programId).then((res) => {
        console.log(res);
        this.classesData = res.data.classesData;
        this.topicsData = res.data.topicsData;
        this.$refs.editTrainProgram.dataForm = {
          name: res.data.name,
          principal: res.data.principal,
          bad: res.data.bad,
          good: res.data.good,
          jyr1: res.data.jyr1,
          jyr2: res.data.jyr2,
          jyr3: res.data.jyr3
        };
      });
    },
    changeType(type) {
      this.type = type;
    },
    //选择课程完毕
    confirmClass(e) {
      console.log(e);
      this.classesData.unshift(...e);
    },
    //移除一个课程
    delClass(e) {
      this.classesData.splice(
        this.classesData.findIndex((v) => v.id == e),
        1
      );
    },
    //移除一个题目
    delTopic(e) {
      this.topicsData.splice(
        this.topicsData.findIndex((v) => v.id == e),
        1
      );
    },
    //切换题库
    confirmTopicsCheck(e) {
      this.topicsData = e;
    },
    //选择完题库
    confirmTopics(e) {
      this.topicsData.push(...e);
    },
    //清空题库
    resetTopics() {
      this.topicsData = [];
    },
    //取消新增或编辑方案
    cancel() {
      this.$router.history.go(-1);
    },
    //新增/修改方案
    addorupdateProgram(e) {
      console.log(e);
      if (this.classesData.length == 0) {
        return this.$message.error("请选择培训课程");
      }
      if (this.topicsData.length == 0) {
        return this.$message.error("请选择培训题目");
      }
      const data = {
        ...e,
        id: this.programId,
        classes: this.classesData.map((v) => v.id).join(","),
        topics: this.topicsData.map((v) => v.id).join(","),
      };
      console.log(JSON.parse(JSON.stringify(data)));
      const fn = this.programId ? updateTrainProgram : addTrainProgram;
      this.confirmLoading = true;
      fn(data)
        .then((res) => {
          console.log(res);
          this.$message.success(
            this.programId ? "修改培训方案成功" : "新增培训方案成功"
          );
          this.$router.history.go(-1);
        })
        .finally(() => {
          let a = setTimeout(() => {
            clearTimeout(a);
            this.confirmLoading = false;
          }, 1000);
        });
    },
    //查看题目信息
    showTopic(e) {
      console.log(e);
      this.$refs.showTopic.init(e)
    },
  },
};
</script>

<style>
</style>